export default function filename (uri) {
  return uri.replace(/^.+\/(.+?)((\?|#).+)?$/, '$1');
}
